import { ISubscriptionRequest } from "@gp/hub";
import { OfferSubscriptionResponse } from "@gp/models";
import { MainOfferStore } from "@gp/offer";
import type { RootStore } from "@state/stores/types";
import { action } from "mobx";
import { Subscription } from "rxjs";

export class EventsResultHubStore extends MainOfferStore {
	subscription: Subscription | null;
	isStoreInitialized: boolean;
	ids: string[];
	rootStore: RootStore;
	constructor(ids: string[], rootStore: RootStore) {
		super();
		this.ids = ids;
		this.rootStore = rootStore;
	}

	public getEvent(eventId: string) {
		const events = this.events.filter((e) => e.id === eventId);
		if (events?.length > 0) {
			return events[0];
		}
		return null;
	}

	createFilter(): ISubscriptionRequest {
		return {
			subscriptionId: `bet-slip-event-results-${this.ids.join("/")}`,
			compress: WEBPACK_OFFER_COMPRESS,
			channels: [
				{
					name: "event",
					filter: {
						id: {
							eq: this.ids,
						},
					},
				},
			],
		};
	}

	@action.bound
	onInitialize() {
		if (this.ids?.length > 0) {
			this.subscription = this.rootStore.hub
				.getOfferSubscription(this.createFilter())
				.subscribe({
					next: this.handleResponse,
					error: this.handleError,
				});
		}
	}

	@action.bound
	handleResponse(data: OfferSubscriptionResponse) {
		this.isStoreInitialized = true;
		this.assignOfferData(data);
	}

	@action.bound
	public handleError(err: any): void {
		console.error(err);
	}

	@action.bound
	disposeSubscription() {
		if (this.subscription != null) {
			this.subscription.unsubscribe();
			this.subscription = null;
		}
	}

	@action.bound
	onDispose() {
		this.isStoreInitialized = false;
		this.ids = [];
		this.disposeSubscription();
		this.reset();
	}
}
